import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import Header from 'components/Header';
import Debug from 'components/Debug';
import MaintenanceBanner from 'components/MaintenanceBanner';
import { useAuth } from 'services/authentication';

export const useDefaultDashboardRedirect = () => {
    const { user } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (window.location.pathname === '/') {
            let redirectUrl;
            if (user.defaultDashboardId) {
                redirectUrl = `/dashboards/${user.defaultDashboardId}`;
            } else if (user.dashboards.length > 0) {
                redirectUrl = `/dashboards/${user.dashboards[0].id}`;
            } else {
                redirectUrl = '/dashboards';
            }
            navigate(redirectUrl);
        }
    }, [user]);
};

export default function Root() {
    const [dashboardLastUpdatedAt, setDashboardLastUpdatedAt] = useState(null);
    const [dashboardName, setDashboardName] = useState(null);
    const [dashboardId, setDashboardId] = useState(null);
    const [filterAlertedFlights, setFilterAlertedFlights] = useState(false);
    const { user } = useAuth();

    const showDebug = user.permissions.role === 'admin' || process.env.NODE_ENV !== 'production';

    const toggleFilterAlertedFlights = () => {
        setFilterAlertedFlights(!filterAlertedFlights);
    };

    useDefaultDashboardRedirect();

    return (
        <div id="route-root" data-testid="route-root">
            <MaintenanceBanner />
            <Toaster />
            <Header
                dashboardId={dashboardId}
                dashboardName={dashboardName}
                dashboardLastUpdatedAt={dashboardLastUpdatedAt}
                filterAlertedFlights={filterAlertedFlights}
                onToggleFilterAlertedFlights={toggleFilterAlertedFlights}
            />
            {showDebug && <Debug />}
            <Outlet context={{ setDashboardId, setDashboardName, setDashboardLastUpdatedAt, filterAlertedFlights }} />
        </div>
    );
}
